module.exports = __webpack_public_path__ + "img/glow-blue-medium.b8feadb4.png";